export default {
  namespaced: true,
  state: {
    terminal: '',
    tab_bar_index: 0,
    buy_prescription: false,
    system_info: {},
    jyJPush: null,
    networkStatus: true,
    prePageList: []
  },
  mutations: {
    setTabBarIndex(state, index) {
      state.tab_bar_index = index
    },
    setTerminal(state, terminal) {
      state.terminal = terminal
    },
    setSystemInfo(state, data) {
      state.system_info = data
    },
    setDeviceInfo(state, data) {
      state.device_info = data
    },
    setJyJPush(state, data) {
      state.jyJPush = data
    },
    setNetworkStatus(state, data) {
      state.networkStatus = data
    },
    addPrePageList(state, data) {
      const index = state.prePageList.findIndex(m => m === data)
      if (index === -1) {
        state.prePageList.push(data)
      }
    },
    delPrePageList(state, data) {
      const index = state.prePageList.findIndex(m => m === data)
      if (index !== -1) {
        state.prePageList.splice(index, 1)
      }
    },
    clearPrePageList(state, data) {
      state.prePageList = []
    }
  }
}
